export default __webpack_public_path__ + "static/media/Neeraj Zaanse_Schans.b3b986c2.jpg";